import type { GatedCall } from '@/lib/guest-auth/types';

/** The `tool_approval_confirmation_shown` properties, on every channel that shows one. */
export function confirmationShownProperties({
  toolName,
  toolCallId,
  threadId,
  channel,
}: GatedCall & {
  threadId?: string;
  channel: 'web' | 'whatsapp';
}) {
  return { toolName, toolCallId, ...(threadId && { threadId }), channel };
}
